import { defineMessages } from 'react-intl';

export default defineMessages({
	firstDescription: {
		id: 'components.walletPayment.confirmExitModal.firstDescription',
		defaultMessage: 'آیا از ادامه فرایند پرداخت در تخفیفان منصرف شدید؟',
	},
	secondDescription: {
		id: 'components.walletPayment.confirmExitModal.secondDescription',
		defaultMessage: ' در صورت تایید لازم است دوباره فرآیند را طی کنید.',
	},
	dismissButton: {
		id: 'components.walletPayment.confirmExitModal.dismissButton',
		defaultMessage: 'نه ادامه می‌دهم',
	},
	exitButton: {
		id: 'components.walletPayment.confirmExitModal.exitButton',
		defaultMessage: 'بله منصرف شدم',
	},
});
